<template>
  <div>
    <el-select class="w-full" clearable multiple v-model="question.issue.voteAnswer" placeholder="请选择">
      <el-option
          v-for="item in items"
          :key="item.id"
          :label="item.content.text"
          :value="item.id">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { questionType } from 'dygc'

export default {
  name: 'VoteChoiceSearch',
  type: [questionType.SINGLE_CHOICE, questionType.MULTIPLE_CHOICE, questionType.SINGLE_SELECT, questionType.MULTIPLE_SELECT,questionType.IMAGE_CHOICE,questionType.IMAGE_MULTIPLE_CHOICE],
  props: {
    question: Object
  },
  data() {
    return {
    }
  },
  computed: {
    items() {
      return this.question.issue.items
    }
  }
}
</script>

<style scoped>

</style>